// Dependency
import React from 'react';

// Styles
import * as styles from './cart-banner.module.scss';

// Template
const CartBanner = ({ children }) => {
  return (
    <div className={`${styles.cartBanner}`}>
      { children }
    </div>
  );
};

export default CartBanner;